export const TELNYX_EVENT_TYPES = {
  numberOrder: {
    complete: 'number_order.complete',
  },
}
